var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.5C7.3125 12.5 7 12.1875 7 11.75C7 11.3438 7.3125 11 7.75 11H8.78125C9.625 8.125 12.3125 6 15.5 6H16.25C16.6562 6 17 6.34375 17 6.75C17 7.1875 16.6562 7.5 16.25 7.5H15.5C13.1562 7.5 11.1562 8.96875 10.3438 11H15.25C15.6562 11 16 11.3438 16 11.75C16 12.1875 15.6562 12.5 15.25 12.5H10C10 12.6875 10 12.8438 10 13C10 13.1875 10 13.3438 10 13.5H15.25C15.6562 13.5 16 13.8438 16 14.25C16 14.6875 15.6562 15 15.25 15H10.3438C11.1562 17.0625 13.1562 18.5 15.5 18.5H16.25C16.6562 18.5 17 18.8438 17 19.25C17 19.6875 16.6562 20 16.25 20H15.5C12.3125 20 9.625 17.9062 8.78125 15H7.75C7.3125 15 7 14.6875 7 14.25C7 13.8438 7.3125 13.5 7.75 13.5H8.5C8.5 13.3438 8.5 13.1875 8.5 13C8.5 12.8438 8.5 12.6875 8.5 12.5H7.75Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/Euro.b11134fe9af139a1d4726700ca5c386c.svg";
export { ForwardRef as ReactComponent };